import { useAuthStore } from '@/stores/authStore';
export type AssistantAuthState = ReturnType<typeof useAuthStore.getState>;
export function assistantPrincipalSnapshot(auth: AssistantAuthState = useAuthStore.getState()) {
  return {
    epoch: auth.sessionEpoch,
    family: auth.sessionFamilyId,
    userId: auth.user?.id,
    tenantId: auth.user?.tenantId,
  };
}
export type AssistantPrincipalSnapshot = ReturnType<typeof assistantPrincipalSnapshot>;
/** Identity/session continuity for an already-authorized read; grant requirements remain operation-specific. */
export function sameAssistantPrincipal(
  snapshot: AssistantPrincipalSnapshot,
  auth: AssistantAuthState = useAuthStore.getState()
): boolean {
  const current = assistantPrincipalSnapshot(auth);
  return (
    !auth.isLocked &&
    current.epoch === snapshot.epoch &&
    current.family === snapshot.family &&
    current.userId === snapshot.userId &&
    current.tenantId === snapshot.tenantId
  );
}
